import { isPlatformBrowser } from '@angular/common';
import { register } from 'swiper/element/bundle';

// eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
export function initSwiper(platformId: Object) {
  return () => {
    if (isPlatformBrowser(platformId)) {
      register();
    }
  };
}
